import {
    init
} from "./vue/app";
import {
    initIntersections
} from "../../global/features/lazy-load";

init({});
initIntersections();